module.exports = __webpack_public_path__ + "img/currency-rupee-circle.20fb1a57.svg";